import { DocumentKind } from "@bitory-gmbh/bsm";

export enum GSMDocumentKind {
  Calculation = "calculation",
  Certificate = "certificate",
  Confirmation = "confirmation",
  Contract = "contract",
  Documentation = "documentation",
  LastMinuteRiskAnalysis = "lastminuteriskanalysis",
  Offer = "offer",
  Order = "order",
  Requirement = "requirement",
  Report = "report",
  SummaryReport = "summaryreport",
  Treatment = "treatment",
  WorkOrder = "workorder",
}

export const DocumentKindList: DocumentKind[] = Object.values(GSMDocumentKind);
